// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-header-cell-rs {
    font-size: 15px;
    font-weight: 400;
    color: #000;
}

.table-row-rs{
    cursor: pointer;
}

.table-tree-head {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    text-decoration: underline;
    color: #030192;
}`, "",{"version":3,"sources":["webpack://./src/Components/CustomTable/CustomTable.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;AAClB","sourcesContent":[".table-header-cell-rs {\n    font-size: 15px;\n    font-weight: 400;\n    color: #000;\n}\n\n.table-row-rs{\n    cursor: pointer;\n}\n\n.table-tree-head {\n    cursor: pointer;\n    user-select: none;\n    text-decoration: underline;\n    color: #030192;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
